import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { getLoggedProfile } from "../../model/profile";
import { CAR_REGISTER_SD, CAR_REGISTER_WD, MY_CARS } from "../../constant/routes";

import Header from "../components/header";

import { IcBackReport, IcRegisterStep1, IcRegisterStep2, IcRegisterStep3, IcRegisterStep4 } from "../common/svg";
import register_car from "../../static/images/empty/empty-register-car.svg";

const REGISTER_STEP = [
	{
		id: 1,
		icon: <IcRegisterStep1 />,
		text: "Điền thông tin xe",
	},
	{
		id: 2,
		icon: <IcRegisterStep2 />,
		text: "Tải hình ảnh xe",
	},
	{
		id: 3,
		icon: <IcRegisterStep3 />,
		text: "Mioto tư vấn chủ xe & phê duyệt",
	},
	{
		id: 4,
		icon: <IcRegisterStep4 />,
		text: "Bắt đầu cho thuê",
	},
];

const CarRegisterMode = () => {
	const [allowRegWd, setAllowRegWd] = useState(false);

	useEffect(() => {
		getLoggedProfile().then((resp) => {
			if (resp?.data?.data?.profile) {
				const { profile } = resp.data.data;
				setAllowRegWd(!!profile.allowRegWd);
			}
		});
	}, []);

	return (
		<div className="mioto-layout">
			<Header />
			<section className="body">
				<div className="module-settings min-height-register module-trips">
					<div className="m-container">
						<div className="main-title">
							<Link className="back d-flex" to={MY_CARS}>
								<div className="wrap-svg">
									<IcBackReport />
								</div>
								<p>Quay lại</p>
							</Link>
							<h4>Đăng ký xe</h4>
						</div>
					</div>
					<div className="trip-container">
						<div className="register-mode">
							<img loading="lazy" className="img-fluid" src={register_car} />
							<div className="wrap-2-btn">
								<Link className="btn btn--m btn-primary" to={CAR_REGISTER_SD}>
									Đăng ký xe tự lái
								</Link>
								{allowRegWd ? (
									<Link className="btn btn--m btn-secondary" to={CAR_REGISTER_WD}>
										Đăng ký xe có tài xế
									</Link>
								) : null}
							</div>
						</div>
						<div className="register-content">
							<h6>Gia tăng thu nhập từ 5-10tr/tháng cùng Mioto</h6>
							<div className="content-inner">
								<p className="fontWeight-6">Thủ tục đăng ký 4 bước đơn giản &amp; nhanh chóng:</p>
								<div className="steps">
									{REGISTER_STEP.map((item) => (
										<div className="step-item" key={item.id}>
											<div className="i-svg">
												<div className="wrap-svg">{item.icon}</div>
											</div>
											<p>{item.text}</p>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
					{/* {!allowRegWd && <div className="trip-container">
				<div>Mioto tạm thời dừng tính năng ĐĂNG KÍ MỚI CHỦ XE "CÓ TÀI XẾ" vì đã đủ số lượng xe đăng kí. (Khi kích hoạt lại, Mioto sẽ thông báo đến Quý đối tác qua ứng dụng Mioto trong thời gian sớm nhất. Xin cám ơn sự ủng hộ từ Quý đối tác)</div>
			</div>} */}
				</div>
			</section>
		</div>
	);
};

function mapState(state) {
	return {
		session: state.session,
	};
}

export default connect(mapState)(CarRegisterMode);
